import { IMenuItem } from '../../interfaces';

const PUBLIC_MENU_ITEMS: IMenuItem[] = [
  {
    href: '/pricing',
    label: 'Pricing',
    category: 'Product',
  },
  {
    href: '/blog',
    label: 'Blog',
    category: 'Kanzi',
  },
  {
    href: '/contact',
    label: 'Contact',
    category: 'Kanzi',
  },
];

export { PUBLIC_MENU_ITEMS };
